var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"bcc-button",class:['bcc-button--' + _vm.type,
  {'is-disabled': _vm.disabled},
  _vm.size],attrs:{"disabled":_vm.disabled},on:{"click":_vm.handleClick}},[(_vm.prefixIcon)?_c('div',{staticClass:"prefix-icon"},[_c('i',{class:_vm.prefixIcon})]):_vm._e(),(_vm.$slots.default)?_c('span',[_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }